




































import { snakeCase } from 'lodash'
import { Component, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../Pi/types'
import { DelayNode } from '../../logic/DelayNode'
import { DelayType } from '../../logic/DelayTypes/types'
import {
  ProxyDelayIntervalType,
  ProxyDelayDateType,
  ProxyDelayPropertyType,
} from '../../logic/Proxy/ProxyDelayTypes'
import {
  DelayPropertyType,
  DelayDateType,
  DelayIntervalType,
} from './DelayTypes'

@Component({
  components: {
    DelayDateType,
    DelayIntervalType,
    DelayPropertyType,
  },
  data() {
    return {
      ProxyDelayIntervalType,
      ProxyDelayDateType,
      ProxyDelayPropertyType,
    }
  }
})
export default class DelayNodeSidebar extends UseFields {
  @Prop() node!: DelayNode

  getDelayTypeOptions(): Array<{ label: string, value: DelayType }> {
    return Object.values(DelayType).map((type) => {
      return { label: this.$t(`${ snakeCase(type) }_option`).toString(), value: type }
    })
  }

  swipeDelayType(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.data.swipeDelayType(val)
    return arg
  }
}
